import { render, staticRenderFns } from "./create-order-form.vue?vue&type=template&id=b72195ce&"
import script from "./create-order-form.vue?vue&type=script&lang=js&"
export * from "./create-order-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports